import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  CanActivate, NavigationCancel, NavigationCancellationCode, NavigationEnd,
  NavigationError, NavigationSkipped, NavigationStart, RedirectCommand, Router,
} from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SharedInitGuard implements CanActivate {
  private readonly router = inject(Router);
  private historyNavigation = false;
  private redirecting = false;

  constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
      if (event instanceof NavigationStart) {
        if (!this.redirecting) {
          this.historyNavigation = event.navigationTrigger === 'popstate' || event.navigationTrigger === 'hashchange';
        }
        this.redirecting = false;
      } else if (event instanceof NavigationCancel && event.code === NavigationCancellationCode.Redirect) {
        // Angular restarts guard redirects as imperative navigations; keep the original trigger.
        this.redirecting = true;
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel
        || event instanceof NavigationError || event instanceof NavigationSkipped) {
        this.historyNavigation = false;
        this.redirecting = false;
      }
    });
  }

  get isHistoryNavigation(): boolean {
    const trigger = this.router.getCurrentNavigation()?.trigger;
    return this.historyNavigation || trigger === 'popstate' || trigger === 'hashchange';
  }

  canActivate(): boolean | RedirectCommand {
    return this.isHistoryNavigation
      ? new RedirectCommand(this.router.parseUrl('/home'), { replaceUrl: true })
      : true;
  }
}
